import { PropsWithChildren, useContext } from "react";

import { cn } from "@bentolabs/kit/utils";
import { motion } from "motion/react";

import { TabsContext } from "./context";
import { activeElementVariants, tabVariants } from "./styles";

type Props = {
  disabled?: boolean;
  isActive?: boolean;
  onClick?: () => void;
  className?: string;
};

export const Tab = (props: PropsWithChildren<Props>) => {
  const {
    children,
    className,
    isActive: isActiveProp = false,
    onClick,
    disabled,
    ...restProps
  } = props;

  const {
    lineLayoutId,
    variant,
    color = "spearmint",
    size,
    activeElementClassName,
  } = useContext(TabsContext);

  const isActive = isActiveProp;

  return (
    <button
      className={cn(
        tabVariants({ variant, size, color, active: isActive, className })
      )}
      onClick={onClick}
      data-state={isActive ? "active" : "inactive"}
      style={{
        WebkitTapHighlightColor: "transparent",
      }}
      disabled={disabled}
      {...restProps}
    >
      {isActive && (
        <motion.span
          className={cn(
            activeElementVariants({
              variant,
              color,
              className: activeElementClassName,
            })
          )}
          layoutId={`line-${lineLayoutId}`}
          transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
        />
      )}
      {children}
    </button>
  );
};
